import { deletePersonalKeys } from '@faceup/crypto'
import { clearDecryptCache } from '@faceup/report'
import { clearApolloCache } from '../App/CustomApolloProvider'
import { useAuth } from './auth'

export const useReportAuth = () => {
  const { removeJwt, getJwt } = useAuth()

  const logout = async () => {
    removeJwt()
    deletePersonalKeys()
    clearDecryptCache()
    // Wipe decrypted data from the stable Apollo cache (it no longer resets on
    // language change), so the next reporter never sees the previous session.
    try {
      await clearApolloCache()
    } catch {
      // A failed cache wipe must not block logout - the JWT and personal keys
      // are already gone at this point.
    }
  }

  const isAuthenticated = () => Boolean(getJwt())

  return { logout, isAuthenticated }
}
